// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SetupWorkspaceCategory {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing_unit_6);
  padding: var(--spacing_unit_4);
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-hero {
  width: 100%;
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-content {
  text-align: center;
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-content .SetupWorkspaceCategory-title {
  font-size: 16px;
  margin-bottom: 8px;
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-content .SetupWorkspaceCategory-text {
  font-size: 14px;
  color: var(--color_neutral_800);
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-info {
  display: flex;
  align-items: center;
  gap: var(--spacing_unit_3);
  padding: 0 var(--spacing_unit_4);
  color: var(--color_success_500);
  text-align: center;
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-info svg {
  flex-shrink: 0;
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-info svg path {
  fill: var(--color_success_500);
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-info .SetupWorkspaceCategory-info-text {
  font-size: 14px;
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-form {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing_unit_4);
}
.SetupWorkspaceCategory .SetupWorkspaceCategory-form .SetupWorkspaceCategory-form-actions {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/components/SetupWorkspaceCategory/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,8BAAA;AACF;AACE;EACE,WAAA;AACJ;AAEE;EACE,kBAAA;AAAJ;AAEI;EACE,eAAA;EACA,kBAAA;AAAN;AAGI;EACE,eAAA;EACA,+BAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,gCAAA;EACA,+BAAA;EACA,kBAAA;AAHJ;AAKI;EACE,cAAA;AAHN;AAIM;EACE,8BAAA;AAFR;AAMI;EACE,eAAA;AAJN;AAQE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AANJ;AAQI;EACE,aAAA;EACA,yBAAA;AANN","sourcesContent":[".SetupWorkspaceCategory {\n  display: flex;\n  flex-direction: column;\n  row-gap: var(--spacing_unit_6);\n  padding: var(--spacing_unit_4);\n\n  .SetupWorkspaceCategory-hero {\n    width: 100%;\n  }\n\n  .SetupWorkspaceCategory-content {\n    text-align: center;\n\n    .SetupWorkspaceCategory-title {\n      font-size: 16px;\n      margin-bottom: 8px;\n    }\n\n    .SetupWorkspaceCategory-text {\n      font-size: 14px;\n      color: var(--color_neutral_800);\n    }\n  }\n\n  .SetupWorkspaceCategory-info {\n    display: flex;\n    align-items: center;\n    gap: var(--spacing_unit_3);\n    padding: 0 var(--spacing_unit_4);\n    color: var(--color_success_500);\n    text-align: center;\n\n    svg {\n      flex-shrink: 0;\n      path {\n        fill: var(--color_success_500);\n      }\n    }\n\n    .SetupWorkspaceCategory-info-text {\n      font-size: 14px;\n    }\n  }\n\n  .SetupWorkspaceCategory-form {\n    display: flex;\n    flex-direction: column;\n    row-gap: var(--spacing_unit_4);\n\n    .SetupWorkspaceCategory-form-actions {\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
